module.exports = __webpack_public_path__ + "img/logo3.563d0e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blueoak/logo3.png
// module id = 454T
// module chunks = 83